import React, { useState, useRef, useEffect } from "react";
import { setShowPopupRedux } from "../../Redux/store/onboardingFormSlice";
import { useSelector, useDispatch } from "react-redux";

const ConfirmContinueButton = ({
  buttonText = "Continue",
  onContinue = () => {},
  confirmMessage = "Are you sure you want to continue?",
  confirmTitle = "Save Section",
  iconSrc = "/valid.svg",
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowPopup(false);
        dispatch(setShowPopupRedux(false));
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  return (
    <div
      ref={dropdownRef}
      className=" relative w-full md:w-auto flex justify-center md:justify-end"
    >
      {/* Continue Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          setShowPopup(true);
          dispatch(setShowPopupRedux(true));
        }}
        className="flex w-full md:w-auto items-center justify-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm"
      >
        <span>{buttonText}</span>
      </button>

      {/* Popover */}
      {showPopup && (
        <div className="bottom-actions-save absolute bottom-full mb-3 z-50 w-[90vw] md:w-96 bg-[#005A9C] border border-gray-300 rounded-lg shadow-md p-4">
          <div className="flex items-start space-x-2 text-white font-normal">
            <div>
              <div className="flex flex-row">
                <img src={iconSrc} alt="Icon" className="w-8 h-8" />
                <h2 className="text-md ml-2 mt-1">{confirmTitle}</h2>
              </div>
              <p className="text-xs mt-1">{confirmMessage}</p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-2 mt-4">
            <button
              onClick={() => {
                setShowPopup(false);
                dispatch(setShowPopupRedux(false));
              }}
              className="px-4 py-1 font-medium border border-white text-white rounded-full text-sm"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setShowPopup(false);
                dispatch(setShowPopupRedux(false));
                onContinue(); // Use the prop callback
              }}
              className="px-4 py-1 font-medium bg-white text-black rounded-full text-sm"
            >
              Save & Continue
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmContinueButton;
